module.exports = __webpack_public_path__ + "static/media/zh.7f8455b7.svg";